<div
  class="screen-container horizontal-center"
  (keydown)="handleKeydown($event)"
>
  <app-icon [icon]="'no-internet'"></app-icon>
  <div
    class="container-right vertical-as"
    [ngClass]="{ 'horizontal-focusable-container': isNoInternet }"
  >
    <h3
      [innerHTML]="'global.network.error' | translate"
      [style]="'fontSize.48' | translate"
    ></h3>
    <p
      [innerHTML]="'global.network.error.desc' | translate"
      [style]="'fontSize.28' | translate"
    ></p>
    <app-icon-button
      class="button"
      [label]="'global.retry_btn' | translate"
      (clicked)="networkRetry($event)"
      width="18.07vw"
      height="5.93vh"
    ></app-icon-button>
  </div>
</div>
